import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Image } from '../image/image.component';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
`;

export const BoxWrapper: StyledComponent<'div'> = styled.div`
  width: 100%;
`;

export const DataContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid ${Color.Gray300};
  padding: 16px;
`;

export const ImageWithBoxTitle: StyledComponent<'div'> = styled.div`
  display: flex;
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  object-fit: cover;
  width: 124px;
  height: 162px;
  margin-right: 16px;
  flex-shrink: 0;
`;

export const RemoveButton: StyledComponent<'button'> = styled.button`
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Color.Gray100};
`;

export const EditBar: StyledComponent<'button'> = styled.button`
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: ${FontWeight.Medium};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
  border: 1px solid ${Color.Gray300};
  border-top: none;
`;

export const ArrowsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-direction: column;
  transition: .3s;
  margin: 0 16px;
`;

export const ArrowButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;

  & + & {
    margin-top: 10px;
  }
`;
